import { faBuildingUser, faPersonHalfDress, faSchool } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DatosEmpresas, DatosGenerales, getSession } from "../utils/utils";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function UserData() {
    const navigate = useNavigate();

    const [userInfo, setUserInfo] = useState({
        email: null,
        name: null,
        company: null,
        role: null
    });

    const [cantDatosGenerales, setCantDatosGenerales] = useState({
        cantidad_formularios: null,
        cantidad_capis: null,
    });


    const [cantDatosEmpresas, setCantDatosEmpresas] = useState({
        count: null,
    });

    async function getDatos() {
        setCantDatosGenerales(await DatosGenerales())
        setCantDatosEmpresas(await DatosEmpresas())
    }

    async function getInfo() {
        let session = await getSession();

        if (session !== null) {
            setUserInfo(session);
            return;
        }

        navigate("/");

        return;
    }

    useEffect(function () {
        getInfo();
        getDatos();
    }, []);

    return (
        <div className="pt-4 w-full px-4 h-auto items-center">
            <div className="flex flex-col md:flex-row">
                <div className="flex flex-wrap w-full">
                    <div className="w-full md:w-2/4 px-2 py-2 md:py-0">
                        <Link to="/PerfilUsuario" className="flex flex-row px-3 py-5 bg-custom-yellow w-full rounded-xl h-full transition-colors hover:bg-custom-yellow-hover">
                            <div className="w-1/5 text-center">
                                <FontAwesomeIcon icon={faBuildingUser} className="text-white text-6xl" />
                            </div>
                            <div className="px-5 text-white w-auto font-bold">
                                <h1 className="text-sm">Nombre de Empresa</h1>
                                <p className="text-3xl">
                                    {userInfo?.company === null ? userInfo.name : userInfo.company}
                                </p>
                            </div>
                        </Link>
                    </div>
                    <div className="w-full md:w-1/4 px-2 py-2 md:py-0">
                        <div className="flex flex-row px-3 py-5 bg-custom-cyan w-full rounded-xl h-full">
                            <div className="w-1/4 text-center">
                                <FontAwesomeIcon icon={faPersonHalfDress} className="text-white text-6xl" />
                            </div>
                            <div className="px-3 text-white w-auto font-bold">
                                {userInfo.role === "Admin" ?
                                    <h1 className="text-4xl">{cantDatosGenerales.cantidad_formularios}</h1> :
                                    <h1 className="text-4xl">{cantDatosEmpresas.count}</h1>}
                                <p className="text-sm">Encuestados</p>
                            </div>
                        </div>
                    </div>
                    <div className="w-full md:w-1/4 px-2 py-2 md:py-0">
                        <div className="flex flex-row px-3 py-5 bg-custom-cyan w-full rounded-xl h-full">
                            <div className="w-1/4">
                                <FontAwesomeIcon icon={faSchool} className="text-white text-6xl" />
                            </div>
                            <div className="px-5 text-white w-auto font-bold flex flex-col justify-center">
                                <h1 className="text-4xl">{cantDatosGenerales.cantidad_capis}</h1>
                                <p className="text-sm">CAPIS</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserData;